import { service } from '@ember/service';
import Route from '@ember/routing/route';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class AuthenticatedCareerPathwaysFinanceOptimizerRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const [snapshot, recommendation, lrapDiscovery] = await Promise.all([
      this.reimaginedData.fetchFinancialSnapshot(),
      this.reimaginedData.fetchSection127Recommendation(),
      this.reimaginedData.fetchLrapDiscovery(),
    ]);

    return { snapshot, recommendation, lrapDiscovery };
  }
}
